import { getBlockDef } from "./blockRegistry";

/** Renders an ordered list of CMS blocks by looking up each one's `type`
 * in the block registry and handing its `fields` to the matching
 * presentational component. This is the same renderer used by both the
 * public pages and the admin editor's preview pane, so preview always
 * matches what actually ships. */
export default function BlockRenderer({ blocks = [] }) {
  return (
    <>
      {blocks.map((block) => {
        const def = getBlockDef(block.type);
        if (!def) {
          console.warn(`BlockRenderer: unknown block type "${block.type}"`);
          return null;
        }
        const { Renderer } = def;
        return <Renderer key={block.id} fields={block.fields} />;
      })}
    </>
  );
}
